export const InsuranceConfigEN = {
    "insuranceConfig": {
        "header": "Insurance Config",
        "insuranceConfigConditionsForIncreaseInsurance": "Conditions For Increase Insurance",
        "closingDateForMonthlyIncrease": "Closing date for monthly increase",
        "conditionsForIncreaseInsurance1": "Increasing the number of employees paying social insurance, health insurance and unemployment insurance premiums in this case is understood as an increase in the number of employees participating in paying social insurance, health insurance and unemployment insurance premiums.",
        "conditionsForIncreaseInsurance2": "Increments before this date will be reported for this month, and after this date will be reported for the next month.",
        "signEmployeeContract": "Sign CurrentEmployee Contract",
        "backToWorkMaternity": "Back to work maternity",
        "backToWorkUnpaid": "Back to work unpaid",
        "incrementAmount": "Increment Amount",
        "insuranceConfigConditionsForDecreaseInsurance": "Conditions for decrease insurance",
        "closingDateForMonthlyDecrease": "Closing date for monthly decrease",
        "conditionsForDecreaseInsurance1": "Reducing employees paying social insurance, health insurance and unemployment insurance premiums in this case is understood as reducing the number of employees participating in paying social insurance, health insurance and unemployment insurance premiums",
        "conditionsForDecreaseInsurance2": "Any decrease before this date will report a decrease for this month, and after this date will report a decrease for the next month.",
        "decrementReSign": "CurrentEmployee contract with unemployment insurance",
        "offWorkMaternity": "Off work maternity",
        "decrementAmount": "Decrement amount",
        "decrementAmountContent": "In case the employee does not work and does not receive a salary for more than the maximum number of days off every month, he/she will not pay social insurance premiums for that month. This time is not counted to enjoy social insurance.",
        "offWorkUnpaid": "Off work unpaid",
        "unpaidMaxDay": "Unpaid max day in month",
        "insuranceRate": "Insurance Rate",
        "insuranceRateContent": "This setting will apply to all personnel records",
        "insuranceRateFromMonth": "From month",
        "insuranceAmount": "Amount",
        "socialInsuranceRate": "Social Insurance Rate",
        "accidentInsuranceRate": "Accident Insurance Rate",
        "healthInsuranceRate": "Health Insurance Rate",
        "unemploymentInsuranceRate": "Unemployment Insurance Rate",
        "totalInsuranceRate": "Total",
        "placeholderAmount": "Money",
        "placeholderCompany": "COM",
        "placeholderEmployee": "EMP",
        "autoCalculate": "Automatically recalculate coverage from current month",
        "autoCalculateContent": "The gray boxes are the % paid by employees"
    }
}